import {
    NinchatProperties,
    NinchatState,
} from 'api/types'
import {
    extractProperties,
    isEmpty,
} from './'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatRealmMemberUpdatedEvent} from '../types/events'

export const realmMemberUpdated: CaseReducer<NinchatState> = (state, action) => {
    const {
        member_attrs,
        realm_id,
        user_id,
        ...rest
    } = extractProperties<NinchatRealmMemberUpdatedEvent>(action.payload)

    isEmpty(rest)

    state.user_realms[realm_id] ??= {} as NinchatProperties.NinchatUserRealm
    const {realm_members = {}} = state.user_realms[realm_id]
    realm_members[user_id] ??= {} as NinchatProperties.NinchatRealmMember

    realm_members[user_id].member_attrs = member_attrs
}
